/* global dataLayer */

declare global {
  // tslint:disable-next-line: interface-name
  interface Window {
    dataLayer: any
  }
}

export interface IUserTracking {
  onSlideEnd: (elementId: string, description?: string) => void
  onClick: (elementId: string, description?: string) => void
  onEnterPressed: (elementId: string, description?: string) => void
  onInputChange: (elementId: string, description?: string) => void
  onRadioChange: (elementId: string, description?: string) => void
  onRequest: (requestObject: any, description?: string) => void
  onResponse: (responseObject: any, description?: string) => void
  onModalOpen: (description?: string) => void
  onModalClose: (description?: string) => void
  onValidityFailure: (description?: string) => void
  onFileDownload: (description?: string) => void
}

const userTracking = (appName: string) => {
  const inletName: string = appName

  const push = (obj: any) => {
    if (typeof (window.dataLayer) === 'undefined') {
      // tslint:disable-next-line: no-console
      console.log('Missing dataLayer to push: ' + JSON.stringify(obj))
    } else {
      setTimeout(() => {
        window.dataLayer.push(obj)
      }, 0)
    }
  }

  return {

    onSlideEnd: (elementId: string, description?: string) => {
      push({
        event: 'widgetInteraction',
        widgetId: inletName,
        eventType: 'slideEnd',
        elementId,
        description,
      })
    },

    onClick: (elementId: string, description?: string) => {
      push({
        event: 'widgetInteraction',
        widgetId: inletName,
        eventType: 'click',
        elementId,
        description,
      })
    },

    onEnterPressed: (elementId: string, description?: string) => {
      push({
        event: 'widgetInteraction',
        widgetId: inletName,
        eventType: 'enterPressed',
        elementId,
        description,
      })
    },

    onInputChange: (elementId: string, description?: string) => {
      push({
        event: 'widgetInteraction',
        widgetId: inletName,
        eventType: 'inputChange',
        elementId,
        description,
      })
    },

    onRadioChange: (elementId: string, description?: string) => {
      push({
        event: 'widgetInteraction',
        widgetId: inletName,
        eventType: 'radioChange',
        elementId,
        description,
      })
    },

    onRequest: (requestObject: any, description?: string) => {
      push({
        event: 'widgetInteraction',
        widgetId: inletName,
        eventType: 'request',
        requestObject,
        description,
      })
    },

    onResponse: (responseObject: any, description?: string) => {
      push({
        event: 'widgetInteraction',
        widgetId: inletName,
        eventType: 'response',
        responseObject,
        description,
      })
    },

    onModalOpen: (description?: string) => {
      push({
        event: 'widgetInteraction',
        widgetId: inletName,
        eventType: 'modalOpen',
        description,
      })
    },

    onModalClose: (description?: string) => {
      push({
        event: 'widgetInteraction',
        widgetId: inletName,
        eventType: 'modalClose',
        description,
      })
    },

    onValidityFailure: (description?: string) => {
      push({
        event: 'widgetInteraction',
        widgetId: inletName,
        eventType: 'validityFailure',
        description,
      })
    },

    onFileDownload: (description?: string) => {
      push({
        event: 'widgetInteraction',
        widgetId: inletName,
        eventType: 'fileDownload',
        description,
      })
    },

  } as any
}

export default userTracking
